import { render, staticRenderFns } from "./camera-form-step.vue?vue&type=template&id=b4080a82&"
import script from "./camera-form-step.vue?vue&type=script&lang=js&"
export * from "./camera-form-step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports